export default "__VITE_ASSET__8fb64abe__"